module.exports = __webpack_public_path__ + "assets/img/right-title-open-33550a1e.png";